import React from 'react';
import Routes from './routes';
import Header from './components/Header';
import Footer from './components/Footer';
import './assets/styles/styles.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Routes />
      <Footer />
    </div>
  );
}

export default App;
